'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CategoryLink = exports.CategoryPath = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _nodeToolbox = require('@esnpm/node-toolbox');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _forms = require('@esnpm/forms');

var _translate = require('@esnpm/translate');

var _esdb = require('../../actions/esdb');

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _reactToolbox = require('@esnpm/react-toolbox');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryPath = exports.CategoryPath = (_dec = (0, _reactRedux.connect)(function (state) {
	return { categories: state.categories };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	_inherits(CategoryPath, _React$Component);

	function CategoryPath(props) {
		_classCallCheck(this, CategoryPath);

		var _this = _possibleConstructorReturn(this, (CategoryPath.__proto__ || Object.getPrototypeOf(CategoryPath)).call(this, props));

		_this.state = {
			initialized: false
		};
		return _this;
	}

	_createClass(CategoryPath, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			this.props.dispatch((0, _esdb.apiCategoryBreadCrumbs)({ CATEGORY_PATH: this.props.catPath, FILTER_CLASS: this.props.filterClass })).then(function () {
				_this2.setState({ initialized: true });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.state.initialized) return null;
			return _react2.default.createElement(
				'ul',
				{ className: 'CategoryPath' },
				this.getPathElements()
			);
		}
	}, {
		key: 'getPathElements',
		value: function getPathElements() {
			var _this3 = this;

			var path = [];
			return this.props.catPath.split('.').map(function (e) {
				path.push(e);
				var subpath = path.join('.');
				if (subpath == _this3.props.skipCat.slice(0, subpath.length)) return null;
				if (_this3.props.categories.data[subpath] == null) return null;
				return _react2.default.createElement(
					'li',
					{ key: subpath },
					_react2.default.createElement(CategoryLink, { catPath: subpath })
				);
			});
		}
	}]);

	return CategoryPath;
}(_react2.default.Component), _class2.defaultProps = {
	skipCat: "1",
	catPath: "",
	filterClass: "FULL"
}, _class2.propTypes = {
	skipCat: _propTypes2.default.string,
	catPath: _propTypes2.default.string,
	filterClass: _propTypes2.default.string
}, _temp)) || _class);

var CategoryLink = exports.CategoryLink = function (_React$Component2) {
	_inherits(CategoryLink, _React$Component2);

	function CategoryLink(props) {
		_classCallCheck(this, CategoryLink);

		return _possibleConstructorReturn(this, (CategoryLink.__proto__ || Object.getPrototypeOf(CategoryLink)).call(this, props));
	}

	_createClass(CategoryLink, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/category/' + this.props.catPath },
				_react2.default.createElement(_translate.Tr, { path: 'categories.' + this.props.catPath + '.NAME' })
			);
		}
	}]);

	return CategoryLink;
}(_react2.default.Component);